<template>
    <div class="offerBox">
        <div class="photo">
            <div :style="{ backgroundImage: `url(/assets/img/offer/${img})` }"></div>
        </div>
        <div class="l1">Oferta: {{ name }} ({{ powierzchnia }} m<sup>2</sup>)</div>
        <div class="l2">{{ obiektNazwa }} / {{ obiektTransakcjaShort }}</div>
        <div class="l3">Cena: {{ price }} PLN</div>
        <div class="l3">Lokalizacja: {{ lokalizacja }}</div>
        <router-link class="button" :to="`/search/details/${id}`" :key="id">
            <svg viewBox="0 0 330 330" x="0px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" y="0px">
                <path
                    d="M165,0.008C74.019,0.008,0,74.024,0,164.999c0,90.977,74.019,164.992,165,164.992s165-74.015,165-164.992 C330,74.024,255.981,0.008,165,0.008z M165,299.992c-74.439,0-135-60.557-135-134.992S90.561,30.008,165,30.008 s135,60.557,135,134.991C300,239.436,239.439,299.992,165,299.992z"/>
                <path d="M165,130.008c-8.284,0-15,6.716-15,15v99.983c0,8.284,6.716,15,15,15s15-6.716,15-15v-99.983 C180,136.725,173.284,130.008,165,130.008z"/>
                <path
                    d="M165,70.011c-3.95,0-7.811,1.6-10.61,4.39c-2.79,2.79-4.39,6.66-4.39,10.61s1.6,7.81,4.39,10.61 c2.79,2.79,6.66,4.39,10.61,4.39s7.81-1.6,10.609-4.39c2.79-2.8,4.391-6.66,4.391-10.61s-1.601-7.82-4.391-10.61 C172.81,71.61,168.95,70.011,165,70.011z"/>
            </svg>
        </router-link>
    </div>
</template>

<script>
export default {
    name: "OfferListBox",
    props: {
        price: {
            // type: Number,
            required: false
        },
        name: {
            type: String,
            required: false
        },
        id: {
            // type: Number,
            required: false
        },
        currency: {
            type: String,
            required: false,
            default: 'PLN',
        },
        img: {
            type: String,
            required: false,
            default: '/assets/img/offer/house.jpg'
        },
        obiektNazwa: {
            type: String,
            required: false
        },
        obiektTransakcjaShort: {
            type: String,
            required: false
        },
        powierzchnia: {
            type: String,
            required: false
        },
        lokalizacja: {
            type: String,
            required: false
        }
    },
    computed: {
        areaFormatted () {
            return parseFloat(this.powierzchnia).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',');
        },
        priceFormatted () {
            return parseFloat(this.price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',');
        },
        projectImagePath () {
            return process.env.VUE_APP_MODE == 'dev' ? 'https://ara.re4y.eu/assets/img/offer/' : '/assets/img/offer/';
        }
    }
}
</script>

<style lang="scss" scoped>
.offerBox {
    width: 300px;
    min-height: 300px;
    border: solid 1px #aaaaaa;
    font: 16px 'Roboto Condensed';
    margin: 10px 10px;
    padding: 20px;
    position: relative;
    overflow: hidden;

    .photo {
        width: 100%;
        height: 250px;
        overflow: hidden;
        margin-bottom: 20px;
        background-image: url("/assets/no-photo-available.png");
        background-size: cover;
        background-repeat: no-repeat;

        > div {
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            transition: all 300ms ease-out;
            width: 100%;
            height: 100%;
        }

    }

    &:hover > .photo > div {
        transform: scale(1.2);
    }

    .l1 {
        font: 20px 'Roboto Condensed';
        margin-bottom: 10px;
    }
}

a.button {
    //font: 16px 'Roboto Condensed';
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background-color: rgba(#000, .1);
    border: none;
    position: absolute;
    right: 20px;
    bottom: 10px;
    outline: none;
    cursor: pointer;
    font: 40px/40px 'Roboto';
    text-align: center;
    text-decoration: none;
    display: inline-block;
    transition: background-color 300ms;

    &:hover {
        background-color: rgba(#000, .4);
    }
}
</style>